import styles from './Page.module.css'
import React, { useMemo, useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { toJS } from 'mobx'
import { FormBuilderContext } from '../../../../store/store.FormBuilder'

const Page = observer(({ pageStore }) => {
  const PAGE_WIDTH = 1920
  const PAGE_HEIGHT = 1080
  const { zoom } = useContext(FormBuilderContext)
  console.log('page', toJS(pageStore))
  const width = useMemo(() => PAGE_WIDTH * (zoom / 100), [zoom])
  const height = useMemo(() => PAGE_HEIGHT * (zoom / 100), [zoom])

  return (
    <div
      className={styles.page}
      style={{
        width: `${width}px`,
        height: `${height}px`,
        ...pageStore.data.design,
      }}
    >
      {pageStore.elements.map((elementStore, index) => {
        console.log('elements', toJS(elementStore))
        return (
          <div key={index} style={{ ...elementStore.data.design }}>
            {Object.entries(elementStore.data.childs).map(([key, element]) => {
              return (
                <div key={key} style={{ ...element.design }}>
                  {element.type}
                </div>
              )
            })}
          </div>
        )
      })}
    </div>
  )
})

export default Page
